// src/utils/downloadCSV.js
import api from '../services/api';

export async function downloadCSV(apiUrl, params, filename) {
  try {
    const response = await api.get(apiUrl, { params, responseType: 'blob' });
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (err) {
    alert('Download failed: ' + (err.message || 'Unknown error'));
  }
}
